import { makeStyles } from "@material-ui/core/styles";
import commingSoon from "../../../assets/commingSoon.png";
import GoBackButton from "../../../components/1elements/Buttons/IconButtons/GoBackButton";

const TopSection = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <GoBackButton className={classes.goBackButton} />
            <div className={classes.contentWrapper}>
                <div className={classes.topCircle}></div>
                <div className={classes.bottomSquare}></div>
                <img
                    src={commingSoon}
                    alt="commingSoon"
                    className={classes.commingSoonImage}
                />
            </div>
        </div>
    );
};

export default TopSection;

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        height: "50%",
        boxSizing: "border-box",
        backgroundColor: "#F1F1F1",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
    },
    goBackButton: {
        position: "absolute",
        zIndex: 30,
        top: 0,
        right: 0,
        marginTop: "20px",
    },
    contentWrapper: {
        width: "600px",
        height: "300px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
    },
    topCircle: {
        width: "100%",
        height: "100%",
        borderRadius: "300px 300px 0 0",
        backgroundColor: "#D9D9D9",
        marginBottom: "30px",
        position: "absolute",
        zIndex: 10,
    },
    bottomSquare: {
        width: "100%",
        height: "40px",
        backgroundColor: "white",
        boxShadow: "1px black",
        position: "absolute",
        zIndex: 20,
    },
    commingSoonImage: {
        width: "60%",
        position: "absolute",
        zIndex: 30,
    }
}));
